import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { GetDocumentBlueprintQuery } from '@/gql/graphql';
import documentBlueprintKeys from './keyFactory';

const GetDocumentBlueprint = graphql(`
  query GetDocumentBlueprint($id: ID!) {
    documentBlueprint(id: $id) {
      id
      name
      description
      documentPreviewHtml
      addedToAccount
      fieldGroup {
        id
        customFields {
          id
          label
          identifier
          type
          sortIndex
          options
          schema
        }
      }
    }
  }
`);

export type DocumentBlueprint = NonNullable<
  GetDocumentBlueprintQuery['documentBlueprint']
>;

const useGetDocumentBlueprint = (
  id: string | undefined,
  options?: { enabled?: boolean }
) => {
  const { data, ...rest } = useQuery({
    queryKey: documentBlueprintKeys.detail(id ?? ''),
    queryFn: () => gqlClient.request(GetDocumentBlueprint, { id: id! }),
    enabled: (options?.enabled ?? true) && !!id,
  });

  const blueprint = data?.documentBlueprint;

  return { blueprint, data, ...rest };
};

export default useGetDocumentBlueprint;
